// Cloud storage hosts where a shared document is private by default: students
// hand in the link but forget to open up the permissions, so the teacher hits
// an access-denied page instead of the work.
const DRIVE_HOSTS = [
  "drive.google.com",
  "docs.google.com",
  "onedrive.live.com",
  "1drv.ms",
  "sharepoint.com",
  "dropbox.com",
  "icloud.com",
  "box.com",
];

export const isExternalDriveLink = (value: string): boolean => {
  let hostname: string;

  try {
    hostname = new URL(value).hostname.toLowerCase();
  } catch {
    return false;
  }

  return DRIVE_HOSTS.some(
    (host) => hostname === host || hostname.endsWith(`.${host}`),
  );
};
